/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react'
import withStyles from '@material-ui/core/styles/withStyles'
import classNames from 'classnames'
import {
	colorsNew,
	ltGtMediaQuery,
	ltMdMediaQuery,
	ltSmMediaQuery,
} from 'root/src/client/web/commonStyles'
import map from 'ramda/src/map'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'
import Link from 'root/src/client/web/base/Link'
import { splitAndGetLast } from 'root/src/shared/util/ramdaPlus'

const styles = {
	root: {
		position: 'absolute',
		zIndex: -1,
		width: '100%',
		height: '100%',
		overflowX: 'clip',
		'@supports ( -moz-appearance:none )': {
			overflowX: 'initial',
		},
	},
	image: {
		zIndex: -1,
		top: 0,
		position: 'absolute',
		[ltMdMediaQuery]: {
			width: 1000,
		},
		[ltGtMediaQuery]: {
			width: 700,
		},
		[ltSmMediaQuery]: {
			display: 'none',
		},
	},
	right: {
		right: 0,
	},
	left: {
		left: 0,
	},
	// replacement for zIndex: -1 and allows to click a link
	over: {
		zIndex: 1,
		pointerEvents: 'none',
		transition: '.2s width',
	},
}

const ProfileContainer = ({ text, link, style }) => {
	const dynamicStyles = {
		root: {
			...style,
			position: 'absolute',
			borderRadius: '50%',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			transform: 'translate(-50%, -50%)',
			zIndex: 1,
			transition: '.150s background-color',
			pointerEvents: 'all',
			'&:hover': {
				backgroundColor: 'rgba(255, 255, 255, .1)',
			},
			'&:hover > div': {
				opacity: 1,
			},
		},
		tooltip: {
			position: 'absolute',
			opacity: 0,
			borderRadius: 4,
			padding: [[7, 18]],
			bottom: -58,
			background: colorsNew.primary,
			pointerEvents: 'none',
			transition: '.1s opacity',
		},
	}
	return (
		<Link href={link}>
			<div css={dynamicStyles.root}>
				<div css={dynamicStyles.tooltip}>
					<Typography
						variant={typographyVariants.paragraphBold}
					>
						{text}
					</Typography>
				</div>
			</div>
		</Link>
	)
}

export const BackgroundBlobUnstyled = ({
	classes, backgroundData,
}) => {
	const { position = 'right', image, style, hoverLinks } = backgroundData
	const alt = splitAndGetLast('/', image.src)
	return (
		<div
			className={classNames(
				classes.root,

				hoverLinks && classes.over,
			)}
			css={style}
		>
			<img
				className={classNames(
					classes.image,
					classes[position],
				)}
				src={image.src}
				alt={alt}
			/>
			{/* eslint-disable-next-line no-shadow */}
			{hoverLinks && map(({ styles, link, text }) => (
				<ProfileContainer
					key={link}
					link={link}
					text={text}
					style={styles}
				/>
			), hoverLinks)}
		</div>
	)
}

export default withStyles(styles, { name: 'MuiBackgroundBlobUnstyled' })(BackgroundBlobUnstyled)
